import { render, staticRenderFns } from "./dash-ca-history.vue?vue&type=template&id=6c80a0ac&scoped=true&"
import script from "./dash-ca-history.vue?vue&type=script&lang=js&"
export * from "./dash-ca-history.vue?vue&type=script&lang=js&"
import style0 from "./dash-ca-history.vue?vue&type=style&index=0&id=6c80a0ac&scoped=true&lang=css&"
import style1 from "./dash-ca-history.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80a0ac",
  null
  
)

export default component.exports